import { TuiFileLike, TuiInputFilesModule, TuiMarkerIconModule } from '@taiga-ui/kit';
import { TuiLinkModule, TuiSvgModule } from '@taiga-ui/core';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, Input, Self } from '@angular/core';
import { NgIf } from '@angular/common';

import { IconComponent } from '@iss/core/icon';
import { Control, NOOP_VALUE_ACCESSOR } from '@iss/core/forms';

@Component({
  selector: 'wo-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: [ './file-uploader.component.scss' ],
  standalone: true,
  imports: [
    TuiInputFilesModule,
    NgIf,
    TuiMarkerIconModule,
    TuiSvgModule,
    ReactiveFormsModule,
    TuiLinkModule,
    IconComponent,
  ],
})
export class FileUploaderComponent {
  @Input() public maxFileSize = 5 * 1000000; // 5MB
  @Input() public accept = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl<File | null>>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }

  get file(): TuiFileLike | null {
    return this.control.control.value ||  null;
  }
}
